import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";
import {Dict} from "../../../types/pj1dbApi";
import {ArmDocument} from "../../equipmentdb/types/pj1dbApiArm";
import {findArm} from "../../../utils/awsAmplifyUtil";

export interface UseArmParams {
  onChange: (newData: Dict<ArmDocument>[], newStatus: Status) => void;
  keyword: string;
}

export function useArm(params: UseArmParams) {
  const result = useFetchAllQuery<Dict<ArmDocument>>({
    queryFn: query => findArm({
      ...query,
      ...params.keyword === ''
        ? {}
        : {
          query: {
            $or: [
              {"armInfo.name": {"$regex": params.keyword, "$options": "i"}},
              {"armInfo.number": {"$regex": params.keyword, "$options": "i"}},
              {"armInfo.manufacturer": {"$regex": params.keyword, "$options": "i"}},
              {"productInfo.keyword": {"$regex": params.keyword, "$options": "i"}},
              {"productInfo.description": {"$regex": params.keyword, "$options": "i"}},
            ]
          }
        }
    }),
    needToFetchMore: (data, limit) => Object.entries(data ?? {}).length === limit,
  })
  
  const helperResult = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data,
    status: result.status,
  });
  

  return {
    ...result,
    ...helperResult,
  };
}
